module.exports = __webpack_public_path__ + "static/media/watch.3f7148af.svg";